import React, { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

const AUTO_DISMISS_MS = 5500;

const LoginInspirationPopup = () => {
  const { loginInspiration, dismissLoginInspiration } = useAuth();

  useEffect(() => {
    if (!loginInspiration) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      dismissLoginInspiration();
    }, AUTO_DISMISS_MS);

    return () => clearTimeout(timeoutId);
  }, [loginInspiration, dismissLoginInspiration]);

  if (!loginInspiration) {
    return null;
  }

  return (
    <div className="fixed inset-0 z-[100] flex items-start justify-center pt-20 px-4 pointer-events-none">
      <div className="max-w-xl w-full rounded-2xl border border-border bg-white shadow-xl pointer-events-auto">
        <div className="bg-gradient-to-b from-aquaStart to-tealDeep rounded-t-2xl px-5 py-3">
          <p className="text-sm sm:text-base font-semibold text-white text-center">
            Congratulations for showing up today.
          </p>
        </div>
        <div className="px-5 py-4 text-center">
          <p className="text-sm sm:text-base text-textPrimary leading-relaxed italic">
            “{loginInspiration.quote}”
          </p>
          <button
            type="button"
            onClick={dismissLoginInspiration}
            className="mt-4 inline-flex items-center rounded-md bg-tealDeep px-3 py-1.5 text-xs font-semibold text-white hover:bg-[#237779] transition-colors"
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginInspirationPopup;
